import { render, staticRenderFns } from "./RevenueClientwise.vue?vue&type=template&id=795e577e&"
import script from "./RevenueClientwise.vue?vue&type=script&lang=js&"
export * from "./RevenueClientwise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports